import { __awaiter } from 'tslib';
import { Connection, PublicKey } from '@solana/web3.js';
import { getSolanaDefaultRpcProvider } from '../../rpcProviders.js';
import { DynamicError } from '../../errors.js';

class SolProvider {
    constructor({ solNetworks }) {
        this.solNetworks = solNetworks;
    }
    getDeepLink() {
        return undefined;
    }
    getWeb3Provider() {
        var _a;
        const [network] = this.solNetworks;
        if (!network) {
            throw new DynamicError('No enabled networks');
        }
        const rpcUrl = ((_a = network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || network.rpcUrls[0];
        return new Connection(rpcUrl, 'confirmed');
    }
    getRpcProvider() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.solNetworks.length === 0)
                return;
            const configurations = {
                cosmos: [],
                evm: undefined,
                solana: this.solNetworks,
                starknet: undefined,
            };
            return (_a = getSolanaDefaultRpcProvider(configurations)) === null || _a === void 0 ? void 0 : _a.provider;
        });
    }
    getNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = yield this.getSigner();
            if (!signer)
                return;
            const publicKey = new PublicKey(signer.publicKey.toString());
            const balance = this.lamportsToSol(yield this.getWeb3Provider().getBalance(publicKey));
            return balance.toString();
        });
    }
    // Solana uses lamports as the smallest unit of currency. This converts lamports to SOL.
    lamportsToSol(lamports) {
        return lamports / 1000000000;
    }
}

export { SolProvider };
